export const ADD_COMMENT = "ADD_COMMENT";
export const GET_ALL_COMMENTS = "GET_ALL_COMMENTS";
export const DELETE_ONE_COMMENTS = "DELETE_ONE_COMMENTS";
export const UPDATE_COMMENTS = "UPDATE_COMMENTS";
export const SET_IS_LOADING_COMMENT = "SET_IS_LOADING_COMMENT";